import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import config from './YodaTooltip.config';
import * as styles from './YodaTooltip.css';

const cx = classNames.bind(styles);
/**
 * tooltip placement
 *
 * TOPLEFT -> render tooltip on top of the required element positioned at left
 * BOTTOMRIGHT -> render tooltip at the bottom of the required element positioned at right
 * TOPRIGHT -> render tooltip on top of the required element positioned at right
 * TOPMIDDLE -> render tooltip on top of the required element positioned at middle
 * BOTTOMLEFT -> render tooltip at the bottom of the required element positioned at left
 *
 * */
class YodaTooltip extends Component {
    static propTypes = {
        /*
          Tooltip element on which we wants to get tooltip
        */
        children: PropTypes.oneOfType(PropTypes.string, PropTypes.node, PropTypes.object),
        /**
         * Set style that would be appended to tooltip body and element
         * @type {String}
         */
        tooltipBodyClassName: PropTypes.string,
        tooltipTextClass: PropTypes.string,
        /* callback function to display tooltip data that we wants to display inside tooltip */
        renderTooltipContents: PropTypes.oneOfType(PropTypes.fun, PropTypes.object),
        /* set style that would be appended to tooltip */
        tooltipContentClass: PropTypes.string,
        /* Tolltip direction */
        direction: PropTypes.oneOf([
            config.direction.BOTTOMRIGHT,
            config.direction.BOTTOMLEFT,
            config.direction.BOTTOMMIDDLE,
            config.direction.TOPRIGHT,
            config.direction.TOPLEFT,
            config.direction.TOPMIDDLE,
            config.direction.RIGHT,
            config.direction.RIGHTALIGN,
            config.direction.LEFTALIGN,
        ]),
        tooltipPlacement: PropTypes.oneOf([
            config.tooltipPlacement.RIGHT,
            config.tooltipPlacement.LEFT,
            config.tooltipPlacement.MIDDLE,
        ]),
        triggerEventName: PropTypes.oneOf([
            config.triggerEventName.CLICK,
            config.triggerEventName.MOUSEOVER,
        ]),
        callBackFun: PropTypes.oneOfType(PropTypes.fun, PropTypes.object),
        //    stayInView: PropTypes.bool,
        theme: PropTypes.string,
        /* By default onclick of tooltip conent Tooltip will get hidden - Send false to disable this feature */
        disableHideOnContentClick: PropTypes.bool,
        tabbable: PropTypes.bool,
        btnActiveClass: PropTypes.string,
        placement: PropTypes.string,
        alignAuto: PropTypes.bool,
        isRetailfeeTooltip: PropTypes.bool,
        isCheckoutRetailFee: PropTypes.bool,
    };

    static defaultProps = {
        placement: 'topright',
        children: 'tooltip',
        tooltipBodyClassName: '',
        tooltipTextClass: '',
        renderTooltipContents: '',
        tooltipContentClass: 'tooltip',
        direction: 'Bottomright',
        tooltipPlacement: 'Right',
        triggerEventName: config.triggerEventName.CLICK,
        callBackFun: () => {},
        // stayInView: false,
        theme: '',
        disableHideOnContentClick: false,
        tabbable: false,
        btnActiveClass: '',
        alignAuto: false,
        isRetailfeeTooltip: false,
        isCheckoutRetailFee: false,
    };

    constructor(props) {
        super();
        this.state = {
            isOpen: false,
            direction: props.direction,
            tooltipPlacement: props.tooltipPlacement,
            dynamicAlign: false,
            retailFeeDynamicAlign: false,
        };
        this.getPosition = this.getPosition.bind(this);
        this.onClickTooltip = this.onClickTooltip.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.containerClicked = false;
    }

    componentWillUnmount() {
        this.removeOutsideClickListener();
    }

    onClickTooltip(event) {
        event.nativeEvent.preventDefault();
        if (this.props.triggerEventName !== event.type) return;
        // event.nativeEvent.stopImmediatePropagation();
        this.toggleTooltip(!this.state.isOpen);

        /* if (!this.props.stayInView) {
            this.toggleTooltip(this.state.isOpen);
        } else {
            this.toggleTooltip(!this.state.isOpen);
        } */
    }

    getPosition() {
        const { alignAuto, isCheckoutRetailFee } = this.props;
        if (this.tooltip) {
            // const popupParentWidth = position.width;
            const windowHeight = window.innerHeight;
            const windowWidth = window.innerWidth;
            const {
                width: contentWidth,
                height: contentHeight,
                left: contentLeft,
                bottom: contentBottom,
            } = this.tooltipContentRef.getBoundingClientRect();
            let isExtremeRight = false;
            let isExtremeLeft = false;
            let isExtremeBelow = false;
            if (contentLeft !== 0 && contentWidth !== 0) {
                isExtremeRight = contentLeft + contentWidth > windowWidth;
                isExtremeLeft = contentLeft < 1;
            }
            if (contentBottom !== 0 && contentHeight !== 0) {
                isExtremeBelow = contentBottom - windowHeight > -60;
            }
            /** If content renders beyond viewport
             * change the tooltip direction
             */
            if (alignAuto && isExtremeLeft) {
                this.setState({
                    direction: 'Bottomleft',
                    tooltipPlacement: 'Left',
                    dynamicAlign: true,
                });
            }
            if (alignAuto && isExtremeRight) {
                this.setState({
                    direction: 'Bottomright',
                    tooltipPlacement: 'Right',
                    dynamicAlign: true,
                });
            }
            if (isCheckoutRetailFee && isExtremeRight) {
                this.setState({
                    retailFeeDynamicAlign: true,
                });
            }
            if (this.state.direction === 'Bottommiddle' && isExtremeBelow) {
                this.setState({
                    direction: 'Topmiddle',
                });
            }
            /** restore initial direction if there is enough space below */
            if (
                this.props.direction === 'Bottommiddle' &&
                this.state.direction !== 'Bottommiddle' &&
                !isExtremeBelow
            ) {
                this.setState({
                    direction: 'Bottommiddle',
                });
            }
        }
    }

    setContainerClicked = () => {
        this.containerClicked = true;
    };

    addOutsideClickListener = () => {
        if (!__SERVER__) {
            document.addEventListener('click', this.toggleTooltip, false);
        }
    };

    removeOutsideClickListener = () => {
        if (!__SERVER__) {
            document.removeEventListener('click', this.toggleTooltip, false);
        }
    };

    toggleTooltip(value) {
        let toggle = true;
        const { disableHideOnContentClick, alignAuto } = this.props;
        // If disableHideOnContentClick flag is true and user clicks on tooltip content then tooltip will not be hidden.
        /* istanbul ignore next */
        if (disableHideOnContentClick && this.containerClicked) {
            this.containerClicked = false;
            toggle = false;
        }
        /* istanbul ignore next */
        if (toggle) {
            let placeValue = false;
            if (typeof value === 'boolean') {
                placeValue = value;
            }

            if (this.props.triggerEventName === config.triggerEventName.CLICK) {
                placeValue ? this.addOutsideClickListener() : this.removeOutsideClickListener();
            }
            this.setState(
                {
                    isOpen: placeValue,
                },
                () => {
                    this.props.callBackFun(this.state.isOpen);
                    if (alignAuto) {
                        this.getPosition();
                    }
                }
            );
        }
    }

    render() {
        let btnActiveClass;
        if (this.state.isOpen) {
            btnActiveClass = this.props.btnActiveClass;
        }
        const {
            children,
            tooltipBodyClassName,
            theme,
            tooltipTextClass,
            renderTooltipContents,
            tooltipContentClass,
            triggerEventName,
            tabbable,
            isRetailfeeTooltip,
            isCheckoutRetailFee,
        } = this.props;
        const { direction, tooltipPlacement, dynamicAlign, retailFeeDynamicAlign } = this.state;
        const tooltipClassNames = `${cx('TooltipWrapper', tooltipBodyClassName)} ${dt([
            'relative',
            'inline-block',
            'sm:z-[4]',
            this.state.isOpen && 'sm:z-[6]',
        ])}`;
        const tooltipClassname = `${cx(tooltipTextClass, 'tooltip')} ${dt([
            this.state.isOpen && 'sm:z-[6]',
            'relative',
        ])}`;
        const tooltipContentsClassName = `${cx(
            'tooltip-text',
            theme,
            tooltipContentClass,
            direction,
            tooltipPlacement,
            { alignAuto: dynamicAlign },
            {
                retailfee: isRetailfeeTooltip,
                retailDynamicAlign: retailFeeDynamicAlign,
                checkoutRetailFee: isCheckoutRetailFee,
            }
        )} ${dt(['absolute', 'h-auto', 'text-gray-60', 'sm:z-[1]'])}`;
        const tabbableProps = !tabbable ? { tabIndex: -1 } : {};
        const additionalProps = { onClick: this.setContainerClicked };
        const handlerProps =
            triggerEventName === config.triggerEventName.MOUSEOVER
                ? {
                      onMouseOver: this.onClickTooltip,
                      onMouseLeave: () => this.toggleTooltip(),
                  }
                : {
                      onClick: this.onClickTooltip,
                  };
        return (
            <div
                className={tooltipClassNames}
                role="presentation"
                ref={(node) => {
                    this.tooltip = node;
                }}
                // onMouseDown={this.getPosition}
                data-automation-id="tooltip-container"
            >
                <button
                    type="button"
                    className={cx(tooltipClassname, btnActiveClass)}
                    /* eslint-disable react/jsx-props-no-spreading */
                    {...handlerProps}
                    {...tabbableProps}
                >
                    {children}
                </button>
                <div
                    /* eslint-disable react/jsx-props-no-spreading */
                    {...additionalProps}
                    className={tooltipContentsClassName}
                    data-automation-id="tooltip-content"
                    ref={(tooltipContentRef) => {
                        this.tooltipContentRef = tooltipContentRef;
                    }}
                    style={this.state.isOpen ? { display: 'block' } : { display: 'none' }}
                >
                    {renderTooltipContents}
                </div>
            </div>
        );
    }
}
export default YodaTooltip;
